<p-fieldset>
  <p-header class="article-title">
    <span class="article-title">Faturamento > Negociação de Débitos</span>
  </p-header>

  <div class="p-2">
    <div class="col-5">
      <p>Selecione o Cliente:</p>
      <p-dropdown
        [options]="customers"
        [(ngModel)]="selectedCustomer"
        [placeholder]="'Selecione um Cliente'"
        (onChange)="loadInvoices()"
        [filter]="true"
        [filterPlaceholder]="'Pesquisar Cliente'"
      >
      </p-dropdown>
    </div>

    <div>
      <h2>Faturas em aberto</h2>
      <div class="table">
        <p-table
          #tt
          [value]="invoices"
          [paginator]="false"
          autoLayout="true"
          [globalFilterFields]="[
            'nameCustomer',
            'days',
            'totalCustomer',
            'financialBlock'
          ]"
          [(selection)]="selectedinvoices"
          styleClass="easy-table"
          (selectionChange)="updateHeaderCheckboxState()"
        >
          <ng-template pTemplate="caption">
            <div class="fill-empty"></div>

            <span style="font-weight: bold; float: right; margin-top: 5px"
              >{{ "TOTAL-REGISTERS" | translate }}: {{ tt.totalRecords }}
              {{ "OF" | translate }} {{ invoices?.length }}
            </span>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th class="text-center">
                <p-checkbox
                  binary="true"
                  [(ngModel)]="headerCheckboxChecked"
                  [disabled]="areAllInvoicesDisabled()"
                  (onChange)="onHeaderCheckboxToggle()"
                  [pTooltip]="areAllInvoicesDisabled() ? 'Todas as faturas têm boletos em aberto' : 'Selecionar todas as faturas disponíveis'"
                  tooltipPosition="bottom"
                ></p-checkbox>
              </th>
              <th></th>
              <th class="text-center" [pSortableColumn]="'days'">
                Fatura
                <p-sortIcon [field]="'days'"></p-sortIcon>
              </th>
              <th class="text-center" [pSortableColumn]="'days'">
                Dias em atraso
                <p-sortIcon [field]="'days'"></p-sortIcon>
              </th>
              <th style="text-align: right" [pSortableColumn]="'totalCustomer'">
                Valor das Faturas
                <p-sortIcon [field]="'totalCustomer'"></p-sortIcon>
              </th>
              <th style="text-align: right">
                {{ "Multa" | translate }}
              </th>
              <th style="text-align: right">
                {{ "Mora" | translate }}
              </th>
              <th style="text-align: right">
                {{ "Previsão de Juros" | translate }}
              </th>
              <th style="text-align: right">
                {{ "TOTAL" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-order>
            <tr [ngClass]="{ 'em-danger': order.financialBlock }">
              <td class="text-center d-flex">
                <p-tableCheckbox
                  [value]="order"
                  [disabled]="order?.selectionDisabled"
                >
                </p-tableCheckbox>
              </td>
              <td class="text-left" style="width: 10px">
                <div
                  style="
                    color: red;
                    font-size: x-larger;
                    cursor: pointer;
                    font-weight: bold;
                  "
                  *ngIf="order?.selectionDisabled"
                  pTooltip="Existem Boletos que não foram cancelados no banco."
                  (click)="openBilletsModal(order)"
                >
                  !
                </div>
              </td>
              <td class="text-center">{{ order?.invoiceNumber }}</td>
              <td class="text-center">{{ getDays(order?.dueDate) }}</td>
              <td style="text-align: right">
                {{ order?.value | number : "1.2-2" }}
              </td>
              <td style="text-align: right">
                {{ order?.multa | number : "1.2-2" }}
              </td>
              <td style="text-align: right">
                {{ order?.mora | number : "1.2-2" }}
              </td>
              <td style="text-align: right">
                {{ order?.multa + order?.mora | number : "1.2-2" }}
              </td>
              <td style="text-align: right">
                {{
                  order?.value + order?.multa + order?.mora | number : "1.2-2"
                }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="9" style="text-align: right">
                <div style="display: grid">
                  <strong style="text-align: right; color: red"
                    >"Total de Débitos" :
                    {{ getTotalPending() | number : "1.2-2" }}</strong
                  >

                  <strong class="pt-1" style="text-align: right; color: red"
                    >"Total de juros e multas" :
                    {{
                      getTotalPendingMoraAndMulta() | number : "1.2-2"
                    }}</strong
                  >

                  <strong class="pt-1"
                    >"Valor a Negociar" :
                    {{ getTotalNegotiate() | number : "1.2-2" }}</strong
                  >
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="pt-4" style="text-align: right">
      <p-button
        label="Negociar"
        icon="pi pi-check"
        class="p-button-success"
        (click)="negotiate()"
        [disabled]="!selectedinvoices || selectedinvoices.length === 0"
      ></p-button>
    </div>
  </div>
</p-fieldset>
